import React from "react";
import { ReactLazyImportWithGuard as lazy } from "@lib/lazy-import-with-guard";
import { getCurrentCulture } from "@utils";
import HeaderItemWrapper from "./HeaderItemWrapper";
import UserBalanceDisplay from "@components-shared/mobile/UserBalanceDisplay";

const loadFailPath = `/${getCurrentCulture()}/app-update`;
const RefreshBalanceBtn = lazy(
	loadFailPath,
	() => import("@components/buttons/RefreshBalanceBtn")
);

export default function HeaderUserBalance() {
	return (
		<HeaderItemWrapper>
			<div className="header__balance btn btn--sml btn--rounded btn--split btn--secondary--inverted btn--icon">
				<UserBalanceDisplay isSlim />
				<RefreshBalanceBtn
					atClassName="headerRefreshBalanceBtn"
					className="header__balance__refresh btn btn--round btn--round--xsml btn--split__icon btn--secondary"
					iconOnly
					iconClassName="u-icon--sml u-icon--refresh u-color--core--nero"
				/>
			</div>
		</HeaderItemWrapper>
	);
}
